import { AnamneseOrcadentUploadType } from "libs/media/src/lib";

export interface OrcadentImageOptions {
	id: AnamneseOrcadentUploadType;
	allowed_extensions: string[];
	allowed_max_size: number;
	description: string;
	required: boolean;
	assets?: {
		de: string;
		en: string;
	}
}

const MB = 1024 * 1024;
const MB_5 = MB * 5;
const MB_100 = MB * 100;
const ALLOWED_IMAGE_EXTENSIONS = ['jpg', 'jpeg', 'png', 'dcm', 'dcm30'];

export const ExtraoralImagesOrcadent: OrcadentImageOptions[] = [
	{
		id: AnamneseOrcadentUploadType.EXTRAORAL_FRONT_MOUTH_CLOSED,
		description: 'front mouth closed',
		allowed_extensions: ALLOWED_IMAGE_EXTENSIONS,
		allowed_max_size: MB_5,
		required: false,
	},
	{
		id: AnamneseOrcadentUploadType.EXTRAORAL_FRONT_MOUTH_OPEN,
		description: 'front mouth open',
		allowed_extensions: ALLOWED_IMAGE_EXTENSIONS,
		allowed_max_size: MB_5,
		required: false,
	},
	{
		id: AnamneseOrcadentUploadType.EXTRAORAL_FRONT_SMILE,
		description: 'front smile',
		allowed_extensions: ALLOWED_IMAGE_EXTENSIONS,
		allowed_max_size: MB_5,
		required: true
	},
	{
		id: AnamneseOrcadentUploadType.EXTRAORAL_RIGHT,
		description: 'side view right',
		allowed_extensions: ALLOWED_IMAGE_EXTENSIONS,
		allowed_max_size: MB_5,
		required: false
	},
];

export const IntraoralImagesOrcadent: OrcadentImageOptions[] = [
	{
		id: AnamneseOrcadentUploadType.INTRAORAL_FRONT,
		description: 'front',
		allowed_extensions: ALLOWED_IMAGE_EXTENSIONS,
		allowed_max_size: MB_5,
		required: true,
	},
	{
		id: AnamneseOrcadentUploadType.INTRAORAL_LEFT,
		description: 'left',
		allowed_extensions: ALLOWED_IMAGE_EXTENSIONS,
		allowed_max_size: MB_5,
		required: true,
	},
	{
		id: AnamneseOrcadentUploadType.INTRAORAL_RIGHT,
		description: 'right',
		allowed_extensions: ALLOWED_IMAGE_EXTENSIONS,
		allowed_max_size: MB_5,
		required: true
	},
	{
		id: AnamneseOrcadentUploadType.INTRAORAL_UJ,
		description: 'UJ',
		allowed_extensions: ALLOWED_IMAGE_EXTENSIONS,
		allowed_max_size: MB_5,
		required: true
	},
	{
		id: AnamneseOrcadentUploadType.INTRAORAL_LJ,
		description: 'LJ',
		allowed_extensions: ALLOWED_IMAGE_EXTENSIONS,
		allowed_max_size: MB_5,
		required: true
	},
];

export const MiscellaneousImagesOrcadent: OrcadentImageOptions[] = [
	{
		id: AnamneseOrcadentUploadType.MISC_OPG,
		description: 'OPG',
		allowed_extensions: ALLOWED_IMAGE_EXTENSIONS,
		allowed_max_size: MB_5,
		required: true,
		assets: {
			de: "assets/img/uploader/OPG.png",
			en: "assets/img/uploader/pano.png"
		}
	},
	{
		id: AnamneseOrcadentUploadType.MISC_FRS,
		description: 'FRS',
		allowed_extensions: ALLOWED_IMAGE_EXTENSIONS,
		allowed_max_size: MB_5,
		required: false,
		assets: {
			de: "assets/img/uploader/FRS.png",
			en: "assets/img/uploader/ceph.png"
		}
	}
];


